/**
 * DefrostedReason enum - synchronized with Prisma schema.
 *
 * FOOD_SAFETY is the fish-for-raw-consumption case: freezing is mandatory by law
 * (anisakis), not a fallback. Exposed to the public QR menu so the customer can
 * read why the dish is served defrosted.
 */
export enum DefrostedReason {
  SEASONALITY = 'SEASONALITY',
  FOOD_SAFETY = 'FOOD_SAFETY',
  SUPPLY = 'SUPPLY',
  QUALITY = 'QUALITY',
}
